export const LAUNCH_COMERCIA_WIFI_IS_AVALIABLE = 'LAUNCH_COMERCIA_WIFI_IS_AVALIABLE';
export const COMERCIA_WIFI_IS_AVALIABLE_API_REQUEST = 'COMERCIA_WIFI_IS_AVALIABLE_API_REQUEST';
export const COMERCIA_WIFI_IS_AVALIABLE_API_SUCCESS = 'COMERCIA_WIFI_IS_AVALIABLE_API_SUCCESS';
export const COMERCIA_WIFI_IS_AVALIABLE_API_FAILURE = 'COMERCIA_WIFI_IS_AVALIABLE_API_FAILURE';

export const LAUNCH_COMERCIA_WIFI_AUTHORIZE = 'LAUNCH_COMERCIA_WIFI_AUTHORIZE';
export const COMERCIA_WIFI_AUTHORIZE_API_REQUEST = 'COMERCIA_WIFI_AUTHORIZE_API_REQUEST';
export const COMERCIA_WIFI_AUTHORIZE_API_SUCCESS = 'COMERCIA_WIFI_AUTHORIZE_API_SUCCESS';
export const COMERCIA_WIFI_AUTHORIZE_API_FAILURE = 'COMERCIA_WIFI_AUTHORIZE_API_FAILURE';

export const LAUNCH_COMERCIA_WIFI_REBATE = 'LAUNCH_COMERCIA_WIFI_REBATE';
export const COMERCIA_WIFI_REBATE_API_REQUEST = 'COMERCIA_WIFI_REBATE_API_REQUEST';
export const COMERCIA_WIFI_REBATE_API_SUCCESS = 'COMERCIA_WIFI_REBATE_API_SUCCESS';
export const COMERCIA_WIFI_REBATE_API_FAILURE = 'COMERCIA_WIFI_REBATE_API_FAILURE';

export const LAUNCH_COMERCIA_WIFI_LAST_TRANSACTION = 'LAUNCH_COMERCIA_WIFI_LAST_TRANSACTION';
export const COMERCIA_WIFI_LAST_TRANSACTION_API_REQUEST = 'COMERCIA_WIFI_LAST_TRANSACTION_API_REQUEST';
export const COMERCIA_WIFI_LAST_TRANSACTION_API_SUCCESS = 'COMERCIA_WIFI_LAST_TRANSACTION_API_SUCCESS';
export const COMERCIA_WIFI_LAST_TRANSACTION_API_FAILURE = 'COMERCIA_WIFI_LAST_TRANSACTION_API_FAILURE';

export const COMERCIA_WIFI_NEW_TRANSACTION_REQUEST = 'COMERCIA_WIFI_NEW_TRANSACTION_REQUEST';
export const COMERCIA_WIFI_NEW_TRANSACTION_SUCCESS = 'COMERCIA_WIFI_NEW_TRANSACTION_SUCCESS';
export const COMERCIA_WIFI_NEW_TRANSACTION_FAILURE = 'COMERCIA_WIFI_NEW_TRANSACTION_FAILURE';
